module.exports = __webpack_public_path__ + "img/trash.f6efde51.svg";